import { UploadError } from './UploadError'
import { UnsupportedTypeError } from './UnsupportedTypeError'

const Errors = {
  UploadError,
  UnsupportedTypeError
}

export { Errors }
